import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingTop: theme.spacing(2),
        },
        table: {
            minWidth: '50vw',
        },
        selectButton: {
            backgroundColor: '#FFFFFF',
            marginTop: '5px',
            marginBottom: '5px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            '& > :first-child': {
                marginRight: theme.spacing(1),
            },
        },
        inputWidth: {
            flexBasis: '5%',
        },
        nextButton: {
            paddingTop: theme.spacing(2),
            float: 'right',
        },
        deleteHidden: {
            backgroundColor: theme.palette.error.main,
            height: '63px',
            borderTopRightRadius: '5px',
            borderBottomRightRadius: '5px',
            float: 'right',
            position: 'absolute',
        },
        header: {},
        head: {
            marginTop: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        formControllers: {
            paddingTop: theme.spacing(2),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'flex-end',
        },
        chipButton: {
            backgroundColor: 'transparent',
            border: 'none',
        },
        yearSelector: {
            '&.MuiFormControl-marginNormal': {
                margin: 0,
            },
        },
        outButton: {
            backgroundColor: 'white',
            color: '#bdbdbd',
        },
        chip: {
            color: '#fafafa',
        },
        subheader: {
            margin: theme.spacing(2, 0),
        },
    })
);
